import { useRouter } from '~/hooks/useRouter'

export type Locale = 'ro' | 'ru'

function parseLocaleFromPath(rawPath: string): Locale {
  const clean = (rawPath || '/').split('?')[0].split('#')[0] || '/'
  if (/^\/ru(\/.*)?$/.test(clean)) return 'ru'
  return 'ro'
}

export function useLocale(): Locale {
  const { asPath } = useRouter()
  return parseLocaleFromPath(asPath)
}

type UrlObjectLike = { pathname?: string | null; query?: unknown; [k: string]: unknown }
export type LocaleHref = string | UrlObjectLike

function prefixPath(path: string, locale: Locale): string {
  if (!path.startsWith('/')) return path
  if (path.startsWith('//')) return path
  if (/^\/(ro|ru)(\/|$)/.test(path)) return path
  if (locale === 'ro') return path
  if (path === '/') return '/ru'
  return `/ru${path}`
}

export function withLocale<T extends LocaleHref>(href: T, locale: Locale): T {
  if (typeof href === 'string') return prefixPath(href, locale) as T
  if (href && typeof href === 'object' && typeof href.pathname === 'string') {
    return { ...href, pathname: prefixPath(href.pathname, locale) } as T
  }
  return href
}
